import axios from 'axios';
import { Dao } from '../../dao';
import { IGizmo, IOnlineCatalogRequest } from '../../types';

interface IParams {
  onlineCatalogRequests: IOnlineCatalogRequest[];
  context: {
    dao?: Dao;
    rootGizmoFid: string;
    config: IGizmo;
  };
}

/**
 * Get catalogs from the server
 * @param {IOnlineCatalogRequest[]} onlineCatalogRequests list of online catalog requests that will
 *  be sent to the server
 * @returns
 */
function getOnlineCatalogs({
  onlineCatalogRequests,
  context,
}: IParams): Promise<void> {
  return new Promise<void>(async resolve => {
    const { dao, rootGizmoFid, config } = context;

    if (onlineCatalogRequests.length === 0) {
      return resolve();
    }

    try {
      const apiUrl = dao?.getApiUrl();
      const user = dao?.getUser();
      const credentials: any = user?.credentials;

      if (apiUrl && credentials) {
        const url = `${apiUrl}/main_api/v1/root_gizmo/${rootGizmoFid}/online_catalogs`;

        const response = await axios({
          method: 'POST',
          url,
          data: { online_catalog_requests: onlineCatalogRequests },
          headers: { ...credentials },
        });

        if (response.status === 200) {
          const data = response.data;

          for (const ocRequest of onlineCatalogRequests) {
            const options = data[ocRequest.catalogFid];

            if (options && config.catalogs) {
              const catalog = config.catalogs.find(
                c => c.f_id === ocRequest.catalogFid
              );

              if (catalog) {
                if (!ocRequest.parentCatalogFid) {
                  catalog.options = options;
                } else if (ocRequest.parentOptionFid) {
                  if (Array.isArray(catalog.options)) {
                    catalog.options = {};
                  }

                  catalog.options[ocRequest.parentOptionFid] = options;
                }
              }
            }
          }
        }
      }
    } catch (e) {}

    // After processing we clear the requests
    onlineCatalogRequests = [];
    resolve();
  });
}

export default getOnlineCatalogs;
